/**
 * Agent Dashboard route — /agents/$agentId
 *
 * Accessible by:
 * - Supervisors / Clients / Admins — view any agent's performance
 * - Agents — their own dashboard only (backend enforces RBAC)
 *
 * agentName search param is used as a display placeholder while data loads;
 * installation names the portal of a CRM employee without an account (#1927).
 */

import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AgentDashboard } from '@/components/dashboards/AgentDashboard';

const searchSchema = z.object({
  agentName: z.string().optional(),
  /**
   * The installation of a CRM employee without an Aelo account (#1927): the same
   * `id` in two portals is two people. Absent for an account; absent on an old
   * link — the server then picks the installation with more records.
   */
  installation: z.string().optional(),
});

export const Route = createFileRoute('/agents_/$agentId')({
  validateSearch: searchSchema,
  component: AgentDetailPage,
});

function AgentDetailPage() {
  const { agentId } = Route.useParams();
  const { agentName, installation } = Route.useSearch();
  return (
    <AgentDashboard
      agentId={agentId}
      agentName={agentName}
      installationId={installation}
    />
  );
}
